import * as React from 'react';

import { Search as ArcadiaSearch } from '@abb/arcadia-ui-react';

/* tslint:disable:jsx-no-lambda */
export default class Search extends React.Component<any, any> {
    public render() {
        const { filter, applyFilter, changeFilterField, clearFilter, placeholder } = this.props;
        return (
            <div className='row'>
                <div className='col-lg-12 form-group'>
                    <ArcadiaSearch
                        id='searchFilter'
                        size={32}
                        value={filter}
                        minWidth={200}
                        placeholder={placeholder}
                        onChange={(value: string) => {
                            changeFilterField({ target: { value } });
                            if (value === '' && clearFilter) {
                                setTimeout(() => clearFilter(), 0);
                            }
                        }}
                        onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
                            if (event.key === 'Enter') {
                                event.preventDefault();
                                applyFilter(event);
                            }
                        }}
                        variant="default"
                        handleSearchIconClick={() => applyFilter({ preventDefault: () => undefined })}
                    />
                </div>
            </div>
        );
    }
}

